

document.addEventListener('DOMContentLoaded', () => {
  const form = document.querySelector('.c-pdp-info__form form[action*="/cart/add"]');
  const id = form.querySelector('input[name="id"]');

  const stickyForm = document.querySelector('form.c-pdp__add-form--sticky[action*="/cart/add"]');
  const stickyId = stickyForm.querySelector('input[name="id"]');

  if (!form && !stickyForm) return;

  form.addEventListener('change', function () {
      //Update the hidden input field in the sticky form to match the selected variant
      stickyId.value = id.value;
  });
});
